
import React from 'react';

const TargetGroups: React.FC = () => {
  const groups = [
    { name: 'Fahrschüler', icon: '🚗', tags: ['Pflichtwissen', 'Prüfungsfit'] },
    { name: 'Eltern', icon: '👶', tags: ['Kindernotfälle', 'Sicherheit'] },
    { name: 'Betriebe', icon: '🏢', tags: ['Ersthelfer', 'DSGVO-konform'] },
    { name: 'Senioren', icon: '👵', tags: ['Vorsorge', 'Einfachheit'] }
  ];

  return (
    <div className="container mx-auto px-4 md:px-6">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-5xl font-extrabold text-secondary mb-4">
          Für wen ist die App?
        </h2>
        <p className="text-gray-600 text-lg">Egal ob jung oder alt – Erste Hilfe geht jeden etwas an.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {groups.map((g, i) => (
          <div key={i} className="bg-white border-2 border-gray-100 p-8 rounded-[2rem] text-center hover:border-primary transition-all group cursor-default">
            <div className="text-6xl mb-6 group-hover:scale-110 transition-transform">
              {g.icon}
            </div>
            <h3 className="text-xl font-bold text-secondary mb-4">{g.name}</h3>
            <div className="flex flex-wrap justify-center gap-2">
              {g.tags.map(t => (
                <span key={t} className="bg-gray-100 text-gray-500 text-xs font-bold px-3 py-1 rounded-full">
                  {t}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TargetGroups;
